import './styles/index.scss';
import App from './components/app';

export default App;
